import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { NGXS_LOGGER_PLUGIN_OPTIONS, NgxsLoggerPluginOptions } from '@ngxs/logger-plugin';
import { withNgxsPlugin } from '@ngxs/store';
import { VnextStorageLoggerService } from '../vnext-storage-logger.service';

export const USER_OPTIONS: InjectionToken<NgxsLoggerPluginOptions> = new InjectionToken<NgxsLoggerPluginOptions>(
  'VNEXT_LOGGER_USER_OPTIONS'
);
export const DEFAULT_LOGGER_OPTIONS: NgxsLoggerPluginOptions = {
  logger: console,
  collapsed: false,
  disabled: false,
  filter: action => true
};

export function loggerOptionsFactory(options: NgxsLoggerPluginOptions): NgxsLoggerPluginOptions {
  return { ...DEFAULT_LOGGER_OPTIONS, ...options };
}

export function withVnextStorageLoggerPlugin(options?: NgxsLoggerPluginOptions): EnvironmentProviders {
  return makeEnvironmentProviders([
    withNgxsPlugin(VnextStorageLoggerService),
    {
      provide: USER_OPTIONS,
      useValue: options
    },
    {
      provide: NGXS_LOGGER_PLUGIN_OPTIONS,
      useFactory: loggerOptionsFactory,
      deps: [USER_OPTIONS]
    }
  ]);
}
